export const DOCTORS = [
  {
    id: "carlos",
    name: "Dr. Carlos Silva",
    shortName: "Dr. Carlos",
    specialty: "Cardiologia",
    color: "rose",
    avatar:
      "https://images.unsplash.com/photo-1645066928295-2506defde470?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHw0fHxkb2N0b3IlMjBwb3J0cmFpdCUyMHByb2Zlc3Npb25hbCUyMG1lZGljYWwlMjBjbGluaWN8ZW58MHx8fHwxNzkwMjYyMzMxfDA&ixlib=rb-4.1.0&q=85&w=128&h=128",
  },
  {
    id: "mariana",
    name: "Dra. Mariana Souza",
    shortName: "Dra. Mariana",
    specialty: "Dermatologia",
    color: "violet",
    avatar:
      "https://images.unsplash.com/photo-1659353888906-adb3e0041693?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxkb2N0b3IlMjBwb3J0cmFpdCUyMHByb2Zlc3Npb25hbCUyMG1lZGljYWwlMjBjbGluaWN8ZW58MHx8fHwxNzkwMjYyMzMxfDA&ixlib=rb-4.1.0&q=85&w=128&h=128",
  },
];

// splitClinica = percentual de repasse da clínica (o restante é do médico)
export const INITIAL_APPOINTMENTS = [
  {
    id: 1,
    time: "08:30",
    patient: "Ana Beatriz Ramos",
    procedure: "Consulta + Eletrocardiograma",
    convenio: "Particular",
    doctorId: "carlos",
    value: 350,
    status: "confirmado",
    paid: false,
    splitClinica: 70,
  },
  {
    id: 2,
    time: "09:15",
    patient: "Roberto Mendes Costa",
    procedure: "Avaliação Dermatológica",
    convenio: "Unimed",
    doctorId: "mariana",
    value: 280,
    status: "na_recepcao",
    paid: false,
    splitClinica: 65,
  },
  {
    id: 3,
    time: "10:00",
    patient: "Juliana Ferreira",
    procedure: "Retorno Cardiológico",
    convenio: "Unimed",
    doctorId: "carlos",
    value: 200,
    status: "confirmado",
    paid: false,
    splitClinica: 70,
  },
  {
    id: 4,
    time: "10:45",
    patient: "Fernando Albuquerque",
    procedure: "Mapeamento de Pele (Dermatoscopia)",
    convenio: "Bradesco Saúde",
    doctorId: "mariana",
    value: 420,
    status: "pendente",
    paid: false,
    splitClinica: 65,
  },
  {
    id: 5,
    time: "11:30",
    patient: "Carla Nogueira Lima",
    procedure: "Teste Ergométrico",
    convenio: "Particular",
    doctorId: "carlos",
    value: 480,
    status: "na_recepcao",
    paid: false,
    splitClinica: 70,
  },
  {
    id: 6,
    time: "13:00",
    patient: "Marcos Tavares",
    procedure: "Aplicação de Toxina Botulínica",
    convenio: "Particular",
    doctorId: "mariana",
    value: 950,
    status: "atendido",
    paid: true,
    paymentMethod: "Pix",
    received: 950,
    splitClinica: 60,
  },
  {
    id: 7,
    time: "14:20",
    patient: "Patrícia Gomes",
    procedure: "Consulta Cardiológica",
    convenio: "SulAmérica",
    doctorId: "carlos",
    value: 350,
    status: "pendente",
    paid: false,
    splitClinica: 70,
  },
  {
    id: 8,
    time: "15:10",
    patient: "Eduardo Santana",
    procedure: "Peeling Químico Facial",
    convenio: "Particular",
    doctorId: "mariana",
    value: 300,
    status: "confirmado",
    paid: false,
    splitClinica: 65,
  },
];

export const STATUS_CONFIG = {
  pendente: {
    key: "pendente",
    label: "Pendente",
    sublabel: "IA WhatsApp",
    bg: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-200/70",
    dot: "bg-amber-500",
  },
  confirmado: {
    key: "confirmado",
    label: "Confirmado",
    sublabel: "por IA",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200/70",
    dot: "bg-emerald-500",
  },
  na_recepcao: {
    key: "na_recepcao",
    label: "Na Recepção",
    sublabel: "aguardando",
    bg: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-200/70",
    dot: "bg-blue-500",
  },
  atendido: {
    key: "atendido",
    label: "Atendido",
    sublabel: "finalizado",
    bg: "bg-slate-100",
    text: "text-slate-600",
    border: "border-slate-200",
    dot: "bg-slate-400",
  },
  cancelado: {
    key: "cancelado",
    label: "Cancelado",
    sublabel: "",
    bg: "bg-rose-50",
    text: "text-rose-700",
    border: "border-rose-200/70",
    dot: "bg-rose-500",
  },
};

export const WEEK_DAYS = [
  { key: "seg", label: "Segunda" },
  { key: "ter", label: "Terça" },
  { key: "qua", label: "Quarta" },
  { key: "qui", label: "Quinta" },
  { key: "sex", label: "Sexta" },
  { key: "sab", label: "Sábado" },
];

export const SHIFT_DEFAULTS = {
  manha: { from: "08:00", to: "12:00" },
  tarde: { from: "13:00", to: "18:00" },
};

export const normShift = (v, period) => {
  const d = SHIFT_DEFAULTS[period] || { from: "08:00", to: "12:00" };
  if (v && typeof v === "object") return { active: !!v.active, from: v.from || d.from, to: v.to || d.to };
  return { active: !!v, from: d.from, to: d.to };
};

export const minutesOf = (t) => {
  const [h, m] = String(t || "0:0").split(":").map(Number);
  return (h || 0) * 60 + (m || 0);
};

export const DEFAULT_DURATION = 30;

export const normBlocks = (v, period) => {
  const d = SHIFT_DEFAULTS[period] || { from: "08:00", to: "12:00" };
  if (Array.isArray(v)) return v.filter(Boolean).map((b) => ({ from: b.from || d.from, to: b.to || d.to }));
  if (v && typeof v === "object") return v.active ? [{ from: v.from || d.from, to: v.to || d.to }] : [];
  return v ? [{ from: d.from, to: d.to }] : [];
};

export const buildSlots = (blocks, stepMin = 30) => {
  const out = [];
  (blocks || []).forEach((b) => {
    const s = minutesOf(b.from);
    const e = minutesOf(b.to);
    for (let t = s; t + stepMin <= e; t += stepMin) {
      const h = String(Math.floor(t / 60)).padStart(2, "0");
      const m = String(t % 60).padStart(2, "0");
      out.push(`${h}:${m}`);
    }
  });
  return out;
};

// Valor líquido registrado por consulta = valor pago pelo plano menos a glosa estimada
export const convenioRepasse = (plan, value) => {
  if (!plan) return 0;
  const v = Number(value) || 0;
  const glosa = 1 - (Number(plan.glosaPercent) || 0) / 100;
  return v * glosa;
};

export const STATUS_ORDER = ["pendente", "confirmado", "na_recepcao", "atendido"];

export const PAYMENT_METHODS = ["Pix", "Cartão", "Dinheiro", "Convênio"];

export const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);
